<template lang="html">
<div style="width:100%;background-color:#f3f3f3;height:100%; position: relative">
  <div class="logo-header">
        <v-slide-x-transition mode="out-in" class="hotsite-body" v-if="logoProviderFeedback === ''">
          <div class="titulo-logo mb-4 float-l">
            <img v-show="!loading" src="../../assets/logo.png" alt=""> <h4 v-show="!loading">CondoPlaza</h4>
          </div>
        </v-slide-x-transition>
        <v-slide-x-transition mode="out-in" class="hotsite-body" v-else>
          <img :src="logoProviderFeedback" :key="logoProviderFeedback" alt="">
        </v-slide-x-transition>
        <v-progress-linear v-show="loading" v-bind:indeterminate="true" height="2" class="progrees-line" color="red" background-color="white"></v-progress-linear>
    </div>
  <div class="box-email">      
    <div class="text-xs-center call-cupom">
     <strong>Os condôminos do seu condomínio estão sendo comunicados, via email, neste exato momento.</strong>
    </div>
    <!-- <div class="cupom">
      <input type="text" v-model="cupom" placeholder="código">
    </div> -->
    <div class="text-xs-center call-cupom texto">
      Muito obrigado!
    </div>
    <!-- <v-btn
    large
    v-on:click='goCheckIn'
    class="btn-hotsite"
    block
    >
    Acessar
    <span slot="loader" class="custom-loader">
      <v-icon light>cached</v-icon>
    </span>
  </v-btn> -->
   </div>
  </div>
</template>

<script>
export default {
  props: {
    token: {
      type: String
    },
    type: {
      type: String
    }
  },
  data () {
    return {
      loading: true,
      cupom: ''
    }
  },
  computed: {
    logoProviderCupom () {
      return this.$store.getters.logoProviderCupom
    }
  },
  methods: {
    // goCheckIn () {
    //   if (this.cupom.length < 5) {
    //     this.$store.commit('toastr', {
    //       color: 'warning',
    //       texto: 'cupom invalido'
    //     })
    //   } else {
    //     this.$router.push('/a/Servicos/' + this.cupom)//  + this.cupom
    //   }
    // }
  },
  mounted () {
    this.$store.commit('resetLogo')
    // var data = {
    //   token: this.token,
    //   type: this.type
    // },
    // this.$store.dispatch('getAllInfoCupom', data)
    //     .then((response) => {
    //       this.loading = false
    //     })
    //     .catch((err) => console.log(err))
  }
}
</script>

<style lang="css">
.call-cupom {
  color: #464444;
  padding: 10px;
  font-size: 22px;
}
.cupom{
  border: 1px dashed gray;
  border-radius: 5px;
  margin: 20px;
}
.cupom input{
  font-size: 22px;
  width: 100%;
  text-align: center;
  padding: 0px 15px;
  color: #464444;
  text-transform: uppercase;
}
.texto{
	color: #42964d !important;
}
</style>



// WEBPACK FOOTER //
// Cupom.vue?74328276